/**
 * @file Shared React component — components/common/Button.tsx.
 */

// src/components/common/Button.tsx
import React from "react";
import "./Button.css";

interface ButtonProps {
  label: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  variant?: "primary" | "secondary" | "danger" | "default";
}

const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  type = "button",
  disabled,
  variant = "default",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`btn btn-${variant}`}
    >
      {label}
    </button>
  );
};

/** React component — Button. */
export default Button;
